import { render, staticRenderFns } from "./checkActivities.vue?vue&type=template&id=1c48719e&scoped=true"
import script from "./checkActivities.vue?vue&type=script&lang=js"
export * from "./checkActivities.vue?vue&type=script&lang=js"
import style0 from "./checkActivities.vue?vue&type=style&index=0&id=1c48719e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48719e",
  null
  
)

export default component.exports